import { render, staticRenderFns } from "./FlowRecoverNew.vue?vue&type=template&id=1f0920a3&scoped=true"
import script from "./FlowRecoverNew.vue?vue&type=script&lang=js"
export * from "./FlowRecoverNew.vue?vue&type=script&lang=js"
import style0 from "./FlowRecoverNew.vue?vue&type=style&index=0&id=1f0920a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0920a3",
  null
  
)

export default component.exports